module.exports = "/static/assets/5cdf5ce5126eb158a65b2c110e249b11.png";